import { Modal } from 'antd';
import { X } from 'lucide-react';
import { theme } from 'antd';

interface UserDialogShellProps {
  open: boolean;
  onCancel: () => void;
  eyebrow: string;
  title: string;
  width?: number;
  children: React.ReactNode;
}

export function UserDialogShell({
  open,
  onCancel,
  eyebrow,
  title,
  width = 560,
  children,
}: UserDialogShellProps) {
  const { token } = theme.useToken();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      closable={false}
      width={width}
      destroyOnHidden
      centered
      className="meta-modal"
      styles={{
        mask: { background: 'rgba(0, 0, 0, 0.45)' },
        content: {
          borderRadius: 16,
          border: '1px solid rgba(255, 255, 255, 0.12)',
          overflow: 'hidden',
          padding: 0,
        },
        body: { padding: 0, overflow: 'hidden' },
      }}
      zIndex={1000}
    >
      <button
        type="button"
        onClick={onCancel}
        className="absolute top-4 right-4 z-50 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-zinc-800 text-gray-500 dark:text-gray-400 transition"
        aria-label="Fechar"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="flex flex-col max-h-[80vh]" style={{ backgroundColor: token.colorBgBase }}>
        <div
          className="text-white px-6 py-4 flex-shrink-0"
          style={{
            backgroundColor: '#0d0d0f',
          }}
        >
          <p className="text-[11px] text-white/50 uppercase tracking-wide mb-1">{eyebrow}</p>
          <h2 className="text-[15px] font-semibold">{title}</h2>
        </div>

        <div className="px-6 py-6 flex-1 overflow-y-auto max-h-[calc(80vh-80px)]">{children}</div>
      </div>
    </Modal>
  );
}
